import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  empty_list: 'Ingen tilvalgsgrupper endnu. Opret en ny.',
  fields: {
    name: 'Navn',
    external_id: '{{integration}}-ref.',
    prices: 'Priser',
    available: 'Tilgængelig',
    status: 'Status',
    statuses: {
      good: 'God',
      bad: 'Dårlig',
      medium: 'Middel',
    },
  },
  order_method_prices: {
    base: 'Basis',
    [ORDER_METHODS.pickup]: 'Afhentning',
    [ORDER_METHODS.delivery]: 'Levering',
    [ORDER_METHODS.on_site]: 'Bordbestilling',
  },
  labels: {
    visible: 'Synlig i menuen',
    hidden: 'Alle skjult',
  },
  buttons: {
    add_modifier: 'Tilføj tilvalg',
    delete_modifier_one: 'Slet tilvalg',
    delete_modifier_other: 'Slet tilvalg',
    show_modifier_group: 'Vis tilvalgsgruppe',
    close_modifier_group: 'Luk tilvalgsgruppe',
    edit: 'Rediger',
    duplicate: 'Dupliker',
    history: 'Historik',
  },
  toasts: {
    failed_to_duplicate_modifier_group: 'Tilvalgsgruppen kunne ikke duplikeres',
    modifier_group_duplicated_successfully: 'Tilvalgsgruppen er duplikeret',
    failed_to_duplicate_modifier: 'Tilvalget kunne ikke duplikeres',
    modifier_duplicated_successfully: 'Tilvalget er duplikeret',
  },
};
